import _Toast from "@kibt/meta-ui/es/toast";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { defineComponent, ref, computed, nextTick } from '@vue/composition-api';
import html2canvas from 'html2canvas';
import { useBridge } from '@/utils/yoda';
import { isIOS } from '@/utils/platform';
import ToastLoading from '@/components/loading/toast-loading.vue';
export default defineComponent({
  components: {
    ToastLoading: ToastLoading
  },
  props: {
    // 每个都代表个图片
    selectorElements: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ignoreClass: {
      type: String,
      default: 'publish-ignore'
    },
    savedId: {
      type: [Number, String],
      default: 0
    },
    toastLoading: {
      type: Boolean,
      default: true
    },
    galleryOptions: {
      type: Object,
      default: function _default() {
        return {
          disableStory: false,
          autoAtFriend: false,
          disableAutoRecoMusic: false
        };
      }
    }
  },
  emits: ['post-end', 'post-start'],
  setup: function setup(props, ctx) {
    var referRef = ref(null);
    var savedFilePathMap = {};
    var savedFilePathMapRef = ref({});
    var sideLimit = ref(1080);

    var initSideLimit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var ret;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return useBridge('product', 'getPhotoGalleryLongSideLimit');

              case 2:
                ret = _context.sent;

                // console.log('product', 'getPhotoGalleryLongSideLimit', ret);
                if (ret.result === 1) {
                  // 有可能limit=0,这个时候重置到1080
                  sideLimit.value = ret.limit || 1080;
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initSideLimit() {
        return _ref.apply(this, arguments);
      };
    }();

    var getDpr = function getDpr() {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }

      return 1;
    };

    var sleep = function sleep(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    };

    var percentStepMap = computed(function () {
      var startScreenPercent = 10;
      var end = 5;
      var onePageScreening = Math.floor((100 - startScreenPercent - end) / props.selectorElements.length);
      var surplus = 100 - onePageScreening * props.selectorElements.length - end - startScreenPercent;
      return {
        start: startScreenPercent,
        end: end + surplus,
        pageScreening: onePageScreening,
        allScreening: 100 - end - surplus - startScreenPercent
      };
    });
    var loadingPercent = ref(0);

    var addLoadingPercent = function addLoadingPercent(type) {
      // console.log(percentStepMap.value, loadingPercent.value + percentStepMap.value[type]);
      loadingPercent.value = Math.min(100, loadingPercent.value + percentStepMap.value[type]);
    };

    var setLoadingPercent = function setLoadingPercent(val) {
      loadingPercent.value = val;
    };

    var getScale = function getScale(el) {
      var scale = getDpr();
      var max = Math.max(window.innerWidth * getDpr(), el.clientHeight * getDpr(), sideLimit.value); // 如果宽高超过了最大值，需要把宽高比例缩小至最大值限度

      if (max > sideLimit.value) {
        scale = sideLimit.value / max * getDpr();
      }

      return scale;
    };

    var getScreenShoot = function getScreenShoot(el, ignoreClass) {
      var scale = getScale(el);
      return new Promise(function (resolve) {
        html2canvas(el, {
          scale: scale,
          useCORS: true,
          logging: true,
          width: el.clientWidth,
          height: el.clientHeight,
          ignoreElements: function ignoreElements(element) {
            if (element.classList.contains(ignoreClass)) {
              return true;
            }

            if (element.tagName === 'VIDEO') {
              return true;
            } // && (element as HTMLLinkElement).host !== window.location.host)


            if (element.getAttribute('loading') === 'lazy') {
              // console.log('删除的', element);
              return true;
            }

            return false;
          },
          // allowTa;int: true,
          scrollY: 0
        }).then(function (canvas) {
          var base64 = canvas.toDataURL('image/jpeg'); // 高宽比 

          resolve(base64);
        }).catch(function (e) {});
      });
    };

    var download = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(src) {
        var downloadName,
            a,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                downloadName = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'test';
                a = document.createElement('a');
                a.download = downloadName;
                a.href = src;
                a.dispatchEvent(new MouseEvent('click'));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function download(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var saveImage = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(base64) {
        var ret;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return useBridge('product', 'saveProductImage', {
                  param: {
                    data: base64
                  }
                });

              case 2:
                ret = _context3.sent;

                if (!(ret.result === 1)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", ret.filePath);

              case 5:
                return _context3.abrupt("return", Promise.reject(new Error('saveProductImage error')));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function saveImage(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    var screening = ref(false);

    var toPost = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!screening.value) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                ctx.emit('post-start');
                nextTick(function () {
                  nextToPost();
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function toPost() {
        return _ref4.apply(this, arguments);
      };
    }();

    var nextToPost = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var ret, elements, filePathList;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                screening.value = true; // 安卓检查

                if (isIOS()) {
                  _context6.next = 9;
                  break;
                }

                _context6.next = 4;
                return useBridge('product', 'ensureAndroidProductDfmReady');

              case 4:
                ret = _context6.sent;

                if (!(ret.result !== 1)) {
                  _context6.next = 9;
                  break;
                }

                _Toast.show({
                  text: ctx.root.$k18n({
                    id: 'k_335994'
                  })
                });

                screening.value = false;
                return _context6.abrupt("return");

              case 9:
                _context6.next = 11;
                return initSideLimit();

              case 11:
                addLoadingPercent('start');
                elements = props.selectorElements;
                _context6.prev = 13;

                if (!(props.savedId && savedFilePathMap[props.savedId])) {
                  _context6.next = 19;
                  break;
                }

                filePathList = savedFilePathMap[props.savedId];
                addLoadingPercent('allScreening');
                _context6.next = 23;
                break;

              case 19:
                _context6.next = 21;
                return Promise.all(elements.map( /*#__PURE__*/function () {
                  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(item) {
                    var base64, ret;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return getScreenShoot(item, props.ignoreClass);

                          case 2:
                            base64 = _context5.sent;
                            _context5.next = 5;
                            return saveImage(base64);

                          case 5:
                            ret = _context5.sent;
                            addLoadingPercent('pageScreening');
                            return _context5.abrupt("return", ret);

                          case 8:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x3) {
                    return _ref6.apply(this, arguments);
                  };
                }()));

              case 21:
                filePathList = _context6.sent;

                if (props.savedId) {
                  savedFilePathMap[props.savedId] = filePathList;
                }

              case 23:
                addLoadingPercent('end');

                if (!props.toastLoading) {
                  _context6.next = 27;
                  break;
                }

                _context6.next = 27;
                return sleep(300);

              case 27:
                _context6.next = 29;
                return useBridge('product', 'openPhotoGallery', _objectSpread(_objectSpread({
                  files: filePathList
                }, props.galleryOptions), {}, {
                  disableAutoRecoMusic: false
                }));

              case 29:
                ctx.emit('post-end');
                _context6.next = 35;
                break;

              case 32:
                _context6.prev = 32;
                _context6.t0 = _context6["catch"](13);

                // 出错了
                _Toast.show({
                  text: 'Erro de rede'
                });

              case 35:
                _context6.prev = 35;
                screening.value = false;
                savedFilePathMapRef.value = _objectSpread({}, savedFilePathMap);
                setTimeout(function () {
                  setLoadingPercent(0);
                }, 500);
                return _context6.finish(35);

              case 40:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[13, 32, 35, 40]]);
      }));

      return function nextToPost() {
        return _ref5.apply(this, arguments);
      };
    }();

    return {
      toPost: toPost,
      referRef: referRef,
      screening: screening,
      loadingPercent: loadingPercent,
      savedFilePathMapRef: savedFilePathMapRef
    };
  }
});